import { render, staticRenderFns } from "./semiThirdRound.vue?vue&type=template&id=9fe404d0&scoped=true"
import script from "./semiThirdRound.vue?vue&type=script&lang=js"
export * from "./semiThirdRound.vue?vue&type=script&lang=js"
import style0 from "./semiThirdRound.vue?vue&type=style&index=0&id=9fe404d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe404d0",
  null
  
)

export default component.exports